import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Faq() {
  const { t } = useTranslation();
  const items = t('home.faq.items', { returnObjects: true }) as Array<{ q: string; a: string }>;
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="text-center mb-8">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
          {t('home.faq.title')}
        </h2>
        <p className="mt-2 text-foreground-600 text-sm md:text-base">
          {t('home.faq.subtitle')}
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {items.map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
              <button
                onClick={() => setOpen(isOpen ? null : i)}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-900 text-sm md:text-base">
                  {item.q}
                </span>
                <i className={`ri-add-line text-foreground-500 transition-transform ${isOpen ? 'rotate-45' : ''}`}></i>
              </button>
              {isOpen && (
                <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}